// EventBus.js - 轻量 pub/sub，供网络事件与模块间解耦

class EventBusClass {
    constructor() {
        /** @type {Map<string, Set<Function>>} */
        this.listeners = new Map();
    }

    /**
     * @param {string} event
     * @param {Function} handler
     * @returns {Function} unsubscribe
     */
    on(event, handler) {
        if (!event || typeof handler !== 'function') {
            return () => {};
        }

        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }

        this.listeners.get(event).add(handler);
        return () => this.off(event, handler);
    }

    /**
     * @param {string} event
     * @param {Function} handler
     */
    once(event, handler) {
        if (typeof handler !== 'function') {
            return () => {};
        }

        const wrapper = (...args) => {
            this.off(event, wrapper);
            handler(...args);
        };

        return this.on(event, wrapper);
    }

    /**
     * @param {string} event
     * @param {Function} [handler] - 不传则移除该事件全部监听
     */
    off(event, handler) {
        if (!this.listeners.has(event)) {
            return;
        }

        if (!handler) {
            this.listeners.delete(event);
            return;
        }

        const handlers = this.listeners.get(event);
        handlers.delete(handler);

        if (handlers.size === 0) {
            this.listeners.delete(event);
        }
    }

    /**
     * @param {string} event
     * @param {...*} args
     */
    emit(event, ...args) {
        const handlers = this.listeners.get(event);
        if (!handlers || handlers.size === 0) {
            return;
        }

        [...handlers].forEach((handler) => {
            try {
                handler(...args);
            } catch (error) {
                console.error(`EventBus: 处理器异常 [${event}]`, error);
            }
        });
    }
}

const EventBus = new EventBusClass();
export default EventBus;
